// 1. Primereact styles
import "primereact/resources/primereact.min.css";
// 2. Primeicons
import "primeicons/primeicons.css";
// 3. Primeflex styles
import "primeflex/primeflex.css";
// 4. Primereact theme ext styles
import "./styles/primereact_theme.scss";
// 5. Primereact extensions
import "./styles/primereact_ext.scss";
// 6. Primeflex extensions
import "./styles/primeflex_ext.scss";
// 7. Main styles
import "./main.css";

import { PrimeReactProvider } from "primereact/api";
import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <PrimeReactProvider value={{ ripple: true }}>
    <App />
  </PrimeReactProvider>
  // </StrictMode>
);
